import React from 'react';
import { Clock } from 'lucide-react';
interface StoryCardProps {
  title: string;
  excerpt: string;
  author: string;
  category: string;
  timestamp: string;
  imageUrl?: string;
  compact?: boolean;
}
export function StoryCard({
  title,
  excerpt,
  author,
  category,
  timestamp,
  imageUrl,
  compact = false
}: StoryCardProps) {
  if (compact) {
    return <article className="group cursor-pointer py-4 border-b border-gray-200 last:border-0" data-id="element-87">
        <div className="flex gap-4" data-id="element-88">
          <div className="flex-1" data-id="element-89">
            <span className="text-accent text-xs font-bold uppercase tracking-wider mb-1 block" data-id="element-90">
              {category}
            </span>
            <h3 className="text-lg leading-tight mb-2 group-hover:text-ink-light transition-colors" data-id="element-91">
              {title}
            </h3>
            <div className="flex items-center text-xs text-gray-500 font-body italic" data-id="element-92">
              <span data-id="element-93">{timestamp}</span>
            </div>
          </div>
          {imageUrl && <div className="w-24 h-24 flex-shrink-0 bg-gray-200 overflow-hidden" data-id="element-94">
              <img src={imageUrl} alt="" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-95" />
            </div>}
        </div>
      </article>;
  }
  return <article className="group cursor-pointer h-full flex flex-col" data-id="element-96">
      {imageUrl && <div className="mb-4 overflow-hidden aspect-[3/2] border border-gray-100" data-id="element-97">
          <img src={imageUrl} alt="" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 transform group-hover:scale-105" data-id="element-98" />
        </div>}
      <div className="flex flex-col flex-grow" data-id="element-99">
        <div className="flex items-center justify-between mb-2" data-id="element-100">
          <span className="text-accent text-xs font-bold uppercase tracking-wider" data-id="element-101">
            {category}
          </span>
          <div className="flex items-center text-gray-400 text-xs" data-id="element-102">
            <Clock className="w-3 h-3 mr-1" data-id="element-103" />
            {timestamp}
          </div>
        </div>
        <h3 className="text-xl font-bold leading-tight mb-3 group-hover:text-ink-light transition-colors" data-id="element-104">
          {title}
        </h3>
        <p className="text-ink-light text-sm leading-relaxed mb-4 flex-grow font-body" data-id="element-105">
          {excerpt}
        </p>
        <div className="pt-4 border-t border-gray-100 mt-auto" data-id="element-106">
          <span className="text-xs font-bold font-serif text-gray-900 uppercase" data-id="element-107">
            By{' '}
            <span className="italic normal-case font-body font-normal text-gray-600" data-id="element-108">
              {author}
            </span>
          </span>
        </div>
      </div>
    </article>;
}